import type { RootState } from '~features';

const selectProjectDropsManagerDrops = (state: RootState) => state.projectDropsManager.drops;
const selectProjectDropsManagerIsLoading = (state: RootState): boolean => state.projectDropsManager.isLoading;

export { selectProjectDropsManagerDrops, selectProjectDropsManagerIsLoading };
